import React, { FC } from 'react';
import { GeneralInformation } from '@scope/scope-one-ui/core';
import { useGeneralInformation } from '../../services/esgSentiment';

export const GeneralInformationWidget: FC = () => {
  const { data } = useGeneralInformation();

  return <GeneralInformation labels={data} sentify />;
};
